import { EventBus } from '~/utils/eventBus'
import { createElementFromString, escapeSpecialCharacter } from '~/utils/string'
import { createCustomTooltip } from '~/utils/chart/customTooltips/general'
import type {
  GetBackgroundColor,
  GetTitle,
  GetTooltipBody,
  GetTooltipRow,
  TooltipCallback,
} from '~/utils/chart/customTooltips/definitions'

const onMouseOnChart = (onMouseOnChart: Function) => {
  const tooltipEl = document.getElementById('chartjs-tooltip')
  if (!tooltipEl) return
  if (!onMouseOnChart) tooltipEl.remove()
}

export const getBackgroundColor: GetBackgroundColor = ({ colors, index }) => {
  const color = colors[index]
  return color.backgroundColor
}

export const getTooltipRow: GetTooltipRow = ({ line, background }) => {
  const content = escapeSpecialCharacter(
    line.replace('Tolling Fees', 'Graphitisation Tolling Fees'),
  )

  return `
    <tr>
      <td style="border-left: 3px solid ${background};" class="chartjs-tooltip-label flex font-montserrat text-xs">
        ${content}
      </td>
    </tr>
  `
}

export const getTitle: GetTitle = (titles) => {
  const titleString = titles
    .map(
      (title) => `
      <span class="text-left font-montserrat font-semibold mb-4">
        ${title}
      </span>
    `,
    )
    .join('')
  return createElementFromString(titleString)
}

export const getTooltipBody: GetTooltipBody = ({ colors, bodyLines }) => {
  const mainElement = createElementFromString('<table></table>')

  mainElement.innerHTML = bodyLines
    .map(([line], index: number) =>
      getTooltipRow({
        background: getBackgroundColor({ colors, index }),
        line,
      }),
    )
    .join('')
  return mainElement
}

export const getPriceTooltipContent: TooltipCallback = (context: any) => {
  const { tooltip } = context
  const colors = tooltip.labelColors
  const bodyLines = tooltip.body.map((bodyItem) => bodyItem.lines)
  const title = getTitle(tooltip.title || [])
  const body = getTooltipBody({ colors, bodyLines })
  return [title, body]
}

export const priceCustomTooltip = (context: any) => {
  createCustomTooltip(context, getPriceTooltipContent)

  if (!EventBus._events.mouseonchart) {
    EventBus.$on('mouseonchart', onMouseOnChart)
  }
}

export default priceCustomTooltip
